import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["alt", "data-test", "src"]

type Props = {
  alt?: string
  dataTest?: string
  imageSrc: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageIcon',
  props: {
    alt: { default: 'Image icon' },
    dataTest: { default: 'image-icon' },
    imageSrc: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    alt: _ctx.alt,
    "data-test": _ctx.dataTest,
    src: _ctx.imageSrc,
    class: "image-icon"
  }, null, 8, _hoisted_1))
}
}

})